// extracted by mini-css-extract-plugin
export default {"ctn":"verticallyAndHorizontally_ctn__6W3FE","imgBox":"verticallyAndHorizontally_imgBox__6BGSc","textBox":"verticallyAndHorizontally_textBox__dpnlA"};